import axios from "axios";

export default {
  async getBOTypePiece(idTypePiece) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/admin/typesPiece/" +
        idTypePiece
    );
    return response.data;
  },
  async deleteTypePiece(idTypePiece) {
    const response = await axios.delete(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/admin/typesPiece/" +
        idTypePiece
    );
    return response.data;
  },
  async addTypePiece(typePiece) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/typesPiece",
      typePiece
    );
    return response.data;
  },
  async updateTypePiece(id, typePiece) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/typesPiece/" + id,
      typePiece
    );
    return response.data;
  }
};
